import { render, staticRenderFns } from "./AdvancedSetting.vue?vue&type=template&id=304674aa&scoped=true"
import script from "./AdvancedSetting.vue?vue&type=script&lang=js"
export * from "./AdvancedSetting.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSetting.vue?vue&type=style&index=0&id=304674aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304674aa",
  null
  
)

export default component.exports